export enum DesignEditorStates {
  Normal, UploadLogo, EditLogo, AddText, AddSymbol, AddName, AddNumber, ViewLibrary, ChangeModel
}


